import React, { FC } from "react";
import cn from "classnames";
import { Align, Rotate } from "@baseTypes/baseType";
import st from "./list.module.scss";

interface List extends React.HTMLAttributes<HTMLUListElement> {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  rotate?: Rotate;
  align?: Align;
  wrap?: boolean;
  gap?: number
}

const List: FC<List> = (props) => {
  const {
    children,
    rotate = Rotate.Column,
    align = Align.Start,
    className,
    wrap = true,
    style,
    gap,
    ...rest
  } = props;
  return (
    <ul
      className={cn(
        st.list,
        st[`rotate__${rotate}`],
        st[`align__${align}`],
        wrap && st.wrap,
        className
      )}
      style={{ gap, ...style }}
      {...rest}
    >
      {children}
    </ul>
  );
};
export default List;
